import { render } from "./paydetail.vue?vue&type=template&id=2cdbc434&scoped=true"
import script from "./paydetail.vue?vue&type=script&lang=js"
export * from "./paydetail.vue?vue&type=script&lang=js"

import "./paydetail.vue?vue&type=style&index=0&id=2cdbc434&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdbc434"]])

export default __exports__